/*
早解きの 2 つの道具の名前。日本語を主にし、英語は副題に下げる。
札、見出し、パンくず、メタの題はここから読む (英語だけの札を作らない)
*/
export interface ToolName {
  /** 主の名前 */
  ja: string;
  /** 副題に下げる英語の名前 */
  en: string;
}

export const SQL_RUSH_NAME: ToolName = { ja: "SQL の早解き", en: "SQL Rush" };
export const TERMINAL_RUSH_NAME: ToolName = { ja: "ターミナルの早解き", en: "Terminal Rush" };
